import { gql } from 'graphql-request';

import withFragments from 'utils/graphql';

import ActivityPrice from 'fragments/ActivityPrice';
import ActivitySchedule from 'fragments/ActivitySchedule';
import Logo from 'fragments/Logo';

export default withFragments(
  gql`
    query($id: Int, $contentType: String!, $token: String!, $hostname: String, $themeId: Int) {
      page(id: $id, contentType: $contentType, token: $token) {
        id
        url
        title
        slug
        seoTitle
        seoDescription
        ... on ScheduleOverviewPage {
          metaImage {
            url
          }
          metaTitle
          metaDescription
          logo {
            ...Logo
          }
          breadcrumbs {
            title
            url
          }
        }
      }
      activities(hostname: $hostname, themeId: $themeId) {
        pageType
        ... on ActivityPage {
          activity {
            id
            title
            theme {
              icon
              name
            }
          }
          schedule {
            ...ActivitySchedule
          }
          price {
            ...ActivityPrice
          }
        }
        ... on CustomActivityPage {
          id
          title
          theme {
            icon
            name
          }
          schedule {
            ...ActivitySchedule
          }
          price {
            ...ActivityPrice
          }
        }
      }
      themes {
        id
        name
        position
      }
    }
  `,
  { ActivitySchedule, ActivityPrice, Logo },
);
